import webpack from 'webpack';

export default hash => (
  new webpack.DefinePlugin(hash)
);
